import { Button, Icon, Link, Menu } from "@chakra-ui/react"
import {
  FacebookIcon,
  MailOutline2Icon,
  ShareIcon,
  TwitterXIcon,
} from "@/components/icons"

const ShareDropdown = ({
  articlePathPrefix = "/article",
  handle,
}: {
  handle: string
  articlePathPrefix?: "/article" | "/case-study" | undefined
}) => {
  const articleUrl = `${typeof window !== "undefined" ? window.location.origin : ""}${articlePathPrefix}/${handle}`

  const socialsShare = [
    {
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(articleUrl)}`,
      icon: FacebookIcon,
      name: "Facebook",
    },
    {
      href: `mailto:?subject=Check out this article&body=${encodeURIComponent(articleUrl)}`,
      icon: MailOutline2Icon,
      name: "Email",
    },
    {
      href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(articleUrl)}`,
      icon: TwitterXIcon,
      name: "X/Twitter",
    },
  ]

  return (
    <Menu.Root
      positioning={{
        flip: false,
        placement: "bottom-end",
        sameWidth: false,
      }}
    >
      <Menu.Trigger asChild>
        <Button
          _active={{ transform: "translateY(0px)" }}
          _hover={{ transform: "translateY(-1px)" }}
          aria-label="Share options"
          borderLeft={"1px solid {colors.border}"}
          colorPalette="gray"
          display={"flex"}
          gap="6px"
          h={"full"}
          minH={"64px"}
          outlineColor={"primary.400"}
          px={4}
          py={1}
          rounded="0"
          size="lg"
          title="Share article"
          variant="ghost"
        >
          <Icon as={ShareIcon} color="fg.muted" size={"md"} />
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content rounded="0" shadow="sm">
          {socialsShare.map((item) => (
            <Menu.Item key={item.name} value={item.name}>
              <Link
                aria-label={`Share on ${item.name}`}
                href={item.href}
                rel={item.name !== "Email" ? "noopener noreferrer" : undefined}
                target={item.name !== "Email" ? "_blank" : undefined}
                title={`Share on ${item.name}`}
              >
                <Icon as={item.icon} style={{ marginRight: "8px" }} />
                {item.name}
              </Link>
            </Menu.Item>
          ))}
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  )
}

export default ShareDropdown
